import React from 'react'
import {JSONFetcher, formatCents, gaEvent, findApiV4Link, TimeAgo} from 'shared'
import {Controls} from 'fepp'

export class DonationList extends React.Component {
  state = {}

  componentDidMount() {
    this.loadPage(1)
  }

  // Paginate 3 on mobile?
  loadPage = (page) => {
    const facets = this.props.facets ? `&facets=${this.props.facets}` : ""
    const per_page = this.props.per_page ? this.props.per_page : "6"
    const url = findApiV4Link({ofObject: this.props.fundraisingEvent, withRel: 'opinions'}) + `?per_page=${per_page}&page=${page}${facets}`
    JSONFetcher.load({ url: url, success: response => this.setState(response)})
  }

  loadNextPage = () => {
    this.loadPage(this.state.current_page + 1)
    gaEvent('navigation', 'click donations_arrow_right_button', `to_page ${this.state.current_page + 1}`)
  }

  loadPreviousPage = () => {
    this.loadPage(this.state.current_page - 1)
    gaEvent('navigation', 'click donations_arrow_left_button', `to_page ${this.state.current_page + 1}`)
  }

  inGroupsOf = (arr, length) => {
    return [...Array(Math.ceil(arr.length / length)).keys()].map((i) => {
      const offset = i * length
      return arr.slice(offset, offset + length)
    })
  }

  render() {
    const newDonationUrl = findApiV4Link({ofObject: this.props.fundraisingEvent, withRel: 'new_donation'})

    // Hide while loading
    if (this.state.total_entries === undefined) return null

    const donationRows = this.inGroupsOf(this.state.data, 2).map((group, i) => {
      const donations = group.map((el, j) => <Donation key={`donation-${j}`} {...el} />)
      return <div key={`donation-group-${i}`} className="row">{donations}</div>
    })

    const headline = this.props.headline ? `${this.props.headline} (${this.state.total_entries})` : I18n.t('fundraising_events.opinions.index.headline', { count: this.state.total_entries })

    return <div className="fundraising-events-show-opinions">
      <div className="container">
        <div className="fundraising-events-opinions-index">
          <div className="row">
            <div className="col-md-24">
              <h1 className='font-lg'>
                {headline}
              </h1>

              {this.state.total_entries === 0 && <ZeroResult url={newDonationUrl} />}

              <Controls
                total={this.state.total_pages}
                current={this.state.current_page}
                loadNextPage={this.loadNextPage}
                loadPreviousPage={this.loadPreviousPage}
              />

              {donationRows}
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

const ZeroResult = ({url}) => {
  return <div className='text-center'>
    <p><strong>{I18n.t('fundraising_events.opinions.index.no_donations_notice')}</strong></p>
    <a href={url}>{I18n.t('fundraising_events.opinions.index.call_for_first_donation')}</a>
  </div>
}

const Donation = (props) => {
  const cents = props.donated_amount_in_cents
  const donor = props.author ? props.author.name : I18n.t('fundraising_events.opinions.opinion.anonymous')
  const amountIsSmall = (cents >= 100000) || (cents % 100 > 0)

  // Hardcoded image, FeelsBadMan
  const image = findApiV4Link({ ofObject: ((props.author || {}).picture || {}), withRel: 'fill_100x100' }) || "https://betterplace-assets.betterplace.org/assets/default/donation_profile_picture/fill_100x100_default-2f969919aad3a0d51372c1474e73e452ea00947cb78d944c81aa1891b590b31e.png"

  return <div className='col-md-12'>
    <div className="generic-opinion media">
      <div className="opinion-avatar-and-amount media-left">
        <img className="user-avatar round-image" src={image} width="50" />
        {cents && <div className={`amount ${amountIsSmall ? 'is-small' : ''}`}>{formatCents(cents)}</div>}
      </div>
      <div className="opinion-body media-body">
        <div className="headline">
          <strong dangerouslySetInnerHTML={{ __html: donor }} /> {I18n.t('fundraising_events.opinions.index.donated_label')}
          <br />
          <small><TimeAgo datetime={props.confirmed_at} locale={I18n.locale} /></small>
        </div>
        {props.message && <div className='message' dangerouslySetInnerHTML={{ __html: props.message }} />}
      </div>
    </div>
  </div>
}
